import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=c9fb7c5a&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=c9fb7c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fb7c5a",
  null
  
)

export default component.exports